export const transition = 'all cubic-bezier(0.4, 0, 0.2, 1) 250ms';

export const slowTransition = 'all cubic-bezier(0.4, 0, 0.2, 1) 450ms';
